import {defineStore} from 'pinia'
import {api, coordinator, routes} from "@/plugins/axios";

export const useOrganization = defineStore('useOrganization', {
    state: () => ({
        organization: {
            uid: null,
            slug: null,
        },
        organizations: [],
        loading: false,
        permissions: [],
    }),
    actions: {
        async getOrganizationsByName(name) {
            this.loading = true;
            return coordinator.get(routes.organizations.search(name))
                .then(response => {
                    this.organizations = response.data.data;
                })
                .finally(() => this.loading = false);
        },
        async getOrganizationBySlug(slug) {
            this.loading = true;
            return coordinator.get(routes.organizations.get(slug))
                .then(response => {
                    this.organization = response.data.data;

                    return Promise.resolve(response);
                })
                .finally(() => this.loading = false);
        },
        async getPermissions(slug) {
            this.loading = true;
            return api.get(routes.organization.getRoles(slug))
                .then(response => {
                    let aux = response.data.data.map(item => {
                        return {
                            ...item,
                            formattedName: item.name.split('-').join(' '),
                        }
                    })

                    aux = aux.filter(item => item.name !== 'system');

                    let indexMember = aux.findIndex(item => item.name === 'member');
                    let auxMember = aux[indexMember];

                    aux.splice(indexMember, 1)
                    aux.unshift(auxMember)

                    this.permissions = aux;

                    return Promise.resolve(aux);
                })
                .finally(() => this.loading = false);
        },
    },
    persist: {
        storage: localStorage,
        paths: ['organization']
    }
})
